<template>
  <div style="background-color: #4a3749; height: 100%; background-image: url('./img/background/line-bg.png');  background-repeat: no-repeat;background-size: cover;">
    <div class="started-swiper-box">
      <div class="welcome-handler">
        <img :src="this.$store.state.companyData.locale.logo" id="company-logo" alt="">
        <h5 class="welcome-text">
          {{ $t('Menu disabled') }}<br>
        </h5>
        <h6 style="color: white">{{ $t('Menu disabled contact') }}</h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuDisabled',
  data(){
    return{
      companyName: this.$store.state.companyData.locale ? this.$store.state.companyData.locale.name : 'NO COMPANY',
    }
  },
  created(){

  },
  methods:{

  }
}
</script>

<style scoped>
.welcome-handler {
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}

.welcome-text {
  color: white;
}

#company-logo {
  max-width: 180px;
  background-color: white;
  border-radius: 20px;
  padding: 20px;
}

</style>
